import styled from "styled-components";
import { space } from "styled-system";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import * as Type from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import * as PricePromoIcon from "../../../../../../../common-deprecated/styles/v2/toyota/custom/price/PricePromoIcon";
import * as CashPriceStyles from "../../../../../../../common-deprecated/styles/v2/toyota/custom/price/CashPrice";
import * as Button from "../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import Spacer from "../../../../../../../common-deprecated/styles/v2/toyota/utilities/Spacer";
import FuelTypeLabel from "../../../../../../../common-deprecated/styles/v2/toyota/components/FuelTypeLabel";
import { AvailabilityBadges } from "../../../../../../../common-deprecated/components/aem/toyota/availability-badges/styles/AvailabilityBadgesStyles";

export const Wrapper = styled.div`
    position: relative;
    margin: 0 0 ${theme.space[2]}px;
    padding: ${theme.space[3]}px;
    background-color: ${theme.colors.primaryWhite};

    ${PricePromoIcon.Wrapper} {
        margin-left: ${theme.space[2]}px;
    }

    ${CashPriceStyles.Text} {
        color: ${theme.colors.primaryBlack};
    }

    ${Type.SmallText} {
        color: ${theme.colors.grey7};
    }

    ${FuelTypeLabel} {
        margin-left: ${theme.space[1]}px;
    }

    ${AvailabilityBadges} {
        margin-top: ${theme.space[2]}px;
    }

    html[dir="rtl"] & {
        ${PricePromoIcon.Wrapper} {
            margin-left: 0;
            margin-right: ${theme.space[2]}px;
        }
        ${FuelTypeLabel} {
            margin-left: 0;
            margin-right: ${theme.space[1]}px;
        }
    }
`;

export const Title = styled(Type.H2)`
    font-family: ${theme.fonts.regular};
    font-size: 2rem;

    @media ${getBreakpoint("up", "lg")} {
        font-size: 2.8rem;
    }
`;

export const ModalSubTitle = styled(Type.H2)`
    display: flex;
    align-items: center;
    font-family: ${theme.fonts.regular};
    font-size: 2.2rem;
    line-height: 1.2;
    ${space};

    ${FuelTypeLabel} {
        margin-left: ${theme.space[1]}px;
    }

    html[dir="rtl"] & {
        ${FuelTypeLabel} {
            margin-left: 0;
            margin-right: ${theme.space[1]}px;
        }
    }
`;
export const OptionTitle = styled(Type.H3)`
    display: flex;
    font-family: ${theme.fonts.base};
    font-size: 1.6rem;
    ${space};
`;

export const Footer = styled.div`
    margin-top: ${theme.space[2]}px;
    padding-top: ${theme.space[2]}px;
    text-align: start;
    border-top: 1px solid ${theme.colors.grey2};

    /* Remove spacing from more info button */
    ${Spacer} {
        ${Button.ButtonTertiary} > .btn-text {
            padding: 0 !important;
        }
    }
`;
